import { useOrganizationAccountQuery, useCreateOrganizationAccountMutation, useUpdateOrganizationAccountMutation, useDeleteOrganizationAccountMutation } from './useOrganizationAccountsQuery';
import { OrganizationAccount } from '../types';

export const useOrganizationAccount = (accountId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useOrganizationAccountQuery(accountId || '');
    const createOrganizationAccountMutation = useCreateOrganizationAccountMutation();
    const updateOrganizationAccountMutation = useUpdateOrganizationAccountMutation();
    const deleteOrganizationAccountMutation = useDeleteOrganizationAccountMutation();

    const createRecord = async (values: OrganizationAccount) => {
        return await createOrganizationAccountMutation.mutateAsync(values);
    };

    const updateRecord = async (values: OrganizationAccount) => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }
        return await updateOrganizationAccountMutation.mutateAsync({ id: accountId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }
        return await deleteOrganizationAccountMutation.mutateAsync(accountId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
